import styled from "styled-components";
interface IInputWrapper {
  addMargin?: boolean;
  addRightMargin?: boolean;
  add?: boolean;
  addWidth?: boolean;
}

export const FormInputWrapper = styled.div.attrs({
  // className: "mb-3",
})<IInputWrapper>`
  position: relative;
  margin-bottom: 5px;

  /* width: ${(props) => (props.addWidth ? "70%" : "auto")}; */
  margin-right: ${(props) => (props.add ? "10px" : "0px")};
  margin-right: 10px;
  width: 100%;
  /* z-index: 2099; */
  @media screen and (max-width: 425px) {
    margin: 15px 0px;
  }
`;

export const LabelWrapper = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 0.5rem;
`;

export const CheckBoxLabel = styled.span.attrs({
  className: "text-xs ml-1",
})`
  color: #d9d9d9;
`;

export const Star = styled.span.attrs({
  className: "text-red-500",
})``;

export const InputWrapper = styled.div.attrs((props) => ({
  className: "px-3",
  ...props,
}))`
  background-color: #fbf8fc;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const Input = styled.input.attrs({
  className:
    "mt-1 appearance-none border-none h-15 rounded w-full  text-gray-600 focus:outline-none",
})`
  padding: 0.8rem;
  height: ${(props: { variant: string }) =>
    (props.variant === "sm" && "40px") ||
    (props.variant === "md" && "45px") ||
    (props.variant === "lg" && "50px")};
  background-color: #fbf8fc;

  ::placeholder {
    color: #b199ba;
    font-weight: 300;
    font-size: 14px;
    width: 100%;
  }
`;
export const ErrorMessage = styled.span.attrs({
  className: "text-sm text-red-500",
  name: "ErrorMsg",
})``;

// Shown under a text input/textarea once the value hits its Salesforce-backed
// maxLength, so the user understands why typing stopped (MARCC-690).
export const LimitReachedMessage = styled.span.attrs({
  className: "text-sm text-red-500",
  name: "LimitReachedMsg",
})`
  display: block;
`;

export const PasswordVisibility = styled.span`
  position: absolute;
  top: 37px;
  right: 20px;
`;

export const Label = styled.label.attrs((props) => ({
  className: "font-medium",
  htmlFor: props.htmlFor,
}))`
  font-size: 0.8rem;
`;
